angular.
module("dx.webapp.jobs").
constant("DX_JOB_METADATA_TYPE", Object.freeze({
	DUPLICATE: "duplicate",
	IMPORT: "import",
}));
